window.EmployeeBenefitsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE ? publicConfiguration.tsEmployeeBenefitsServer : publicConfiguration.EmployeeBenefitsServer);

    self.getUserBenefits = function () {
        var deferred = $q.defer();

        _protected.request('employee_benefits', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data.brands && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            })
            .catch(function (err) {
                console.error('err', err);
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getEmployeeBenefits = function (brandId) {
        var deferred = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        _protected.request('brands/' + brandId + '/settings/employee_benefits', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status == 200) {
                    deferred.resolve(res.data.data.benefits);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    self.setEmployeeBenefits = function (brandId, benefit) {
        var deferred = $q.defer();
        var payload = {
            "benefits": benefit
        };
        _protected.request('brands/' + brandId + '/settings/employee_benefits', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status == 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    };
};
